import { Injectable, inject } from '@angular/core'

import type { Observable } from 'rxjs'
import { map } from 'rxjs'

import { ApiService } from '../../api/api.service'
import type { FAQResponseDto } from '../../api/responses'

@Injectable({
  providedIn: 'root',
})
export class FAQService {
  private readonly api = inject(ApiService)

  getAllFAQs(locale: string): Observable<FAQResponseDto> {
    return this.api.getAllFAQs(locale).pipe(
      map(response => {
        return response.data
      })
    )
  }
}
